module.exports = __webpack_public_path__ + "img/symbol_3.e04fc951.png";